import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../redux/store";

const helpfulResourcesInfoState = (state: RootState) => {
    return state.helpfulResources;
};

export const helpfulResourcesDataSelector = createSelector(
    [helpfulResourcesInfoState],
    (helpfulResourcesInfoState) => {
        return helpfulResourcesInfoState?.helpfulResourcesData || {};
    },
);
